export default {"src":"/_next/static/media/AER.59ebbb15.svg","height":18,"width":18};